(() => {
  const callback = () => {
    const SESSION_STORAGE_IS_CLOSED_KEY = 'duplicatesWarningIsClosed';
    const SESSION_STORAGE_COUNT_KEY = 'duplicatesWarningCount';

    const selectors = {
      container: '.cart-duplicates-warning',
      closeButton: '.cart-duplicates-warning__close-button',
    };

    const container = document.querySelector(selectors.container);
    if (!container) return;

    container.addEventListener('click', (event) => {
      if (event.target.closest(selectors.closeButton)) {
        container.classList.add('hidden');
        sessionStorage.setItem(SESSION_STORAGE_IS_CLOSED_KEY, true);
      }
    });

    const getDuplicatesCount = ({ cartItems }) => {
      const counts = (cartItems ?? []).reduce((accumulator, { product_id: productId, variant_id: variantId }) => {
        accumulator[productId] = accumulator[productId] ?? new Set();
        accumulator[productId].add(variantId);

        return accumulator;
      }, {});

      const duplicatesCount = Object.keys(counts).filter((key) => counts[key].size > 1).length;

      return duplicatesCount;
    };

    const onCartRenderHandler = (event) => {
      const { cart } = event.detail ?? {};
      if (!cart) return;

      const duplicatesCount = getDuplicatesCount({ cartItems: cart.items });
      const storedCount = Number(sessionStorage.getItem(SESSION_STORAGE_COUNT_KEY)) || 0;

      sessionStorage.setItem(SESSION_STORAGE_COUNT_KEY, duplicatesCount);

      if (duplicatesCount === 0) {
        container.classList.add('hidden');
        return;
      }

      const hasNewDuplicates = duplicatesCount > storedCount;
      const isWarningClosed = sessionStorage.getItem(SESSION_STORAGE_IS_CLOSED_KEY) === 'true';
      const shouldDisplayWarning = hasNewDuplicates ? hasNewDuplicates : !isWarningClosed;

      if (shouldDisplayWarning) {
        sessionStorage.removeItem(SESSION_STORAGE_IS_CLOSED_KEY);
      }

      container.classList.toggle('hidden', !shouldDisplayWarning);
    };

    document.addEventListener('cart:markup-built', onCartRenderHandler);
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
